import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAppConfigObject } from "../../appConfig.interfaces";

interface IArg {
  query: string;
  config: IAppConfigObject;
  token: string;
}
export const confirmApi: any = createApi({
  reducerPath: "confirmApi",
  baseQuery: fetchBaseQuery({
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Access-Control-Allow-Origin", "*");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchConfirm: builder.query({
      query: (arg: IArg) => {
        return {
          url: `${arg.config.FLIGHT_SEARCH_API_BASE_URL}/confirm?pnr=${arg.query}`,
          method: "GET",
          headers: {
            "X-Confirmation-Token": arg.token,
          },
        };
      },
    }),
  }),
});
export const { useFetchConfirmQuery } = confirmApi;
